'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Lock;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Lock(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M16.6666667,9.33333333 C17.5082434,9.33333333 18.1904762,10.0155661 18.1904762,10.8571429 L18.1904762,18.4761905 C18.1904762,19.3177672 17.5082434,20 16.6666667,20 L7.52380952,20 C6.67809524,20 6,19.3142857 6,18.4761905 L6,10.8571429 C6,10.0155661 6.68223276,9.33333333 7.52380952,9.33333333 L14.3809524,9.33333333 L14.3809524,7.80952381 C14.3809524,6.54715867 13.3576032,5.52380952 12.0952381,5.52380952 C10.832873,5.52380952 9.80952381,6.54715867 9.80952381,7.80952381 L8.28571429,7.80952381 C8.28571429,5.70558191 9.99129619,4 12.0952381,4 C13.1055866,4 14.0745539,4.40135939 14.7889782,5.11578369 C15.5034025,5.83020799 15.9047619,6.79917528 15.9047619,7.80952381 L15.9047619,9.33333333 L16.6666667,9.33333333 Z M12.0952381,16.1904762 C12.9368149,16.1904762 13.6190476,15.5082434 13.6190476,14.6666667 C13.6190476,13.8250899 12.9368149,13.1428571 12.0952381,13.1428571 C11.2536613,13.1428571 10.5714286,13.8250899 10.5714286,14.6666667 C10.5714286,15.5082434 11.2536613,16.1904762 12.0952381,16.1904762 Z'
  }));
}
Lock.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};